import {
  Search,
  Users,
  Gauge,
  FileText,
  ShieldCheck,
  LayoutDashboard,
  Bell,
  SlidersHorizontal,
  FilePlus2,
  FilePen,
  Send,
  BellRing,
  CalendarClock,
  BadgeCheck,
  Sparkles,
  type LucideIcon,
} from 'lucide-react';

/**
 * Frontend-only mapping of an assistant tool `name` → a lucide icon. The catalog
 * from the API carries no icon (it's presentation), so the explore cards and the
 * "/" menu look them up here. `toolIcon()` falls back to a generic spark for any
 * tool the map doesn't know, so a newly-added backend capability still renders.
 */
const TOOL_ICONS: Record<string, LucideIcon> = {
  // read tools (consulta)
  find_client: Search,
  list_clients: Users,
  explain_client_risk: Gauge,
  list_missing_documents: FileText,
  screen_name: ShieldCheck,
  get_dashboard_summary: LayoutDashboard,
  list_alerts: Bell,
  explain_risk_matrix: SlidersHorizontal,
  // write tools (accion)
  create_expediente: FilePlus2,
  update_expediente: FilePen,
  request_documents: Send,
  update_alert: BellRing,
  create_review: CalendarClock,
  run_validation: BadgeCheck,
};

/** Icon for a tool `name`, or a generic fallback when the name is unknown. */
export function toolIcon(name: string): LucideIcon {
  return TOOL_ICONS[name] ?? Sparkles;
}
